import React from 'react';

import * as Styled from './StyledContainer';

export const ContainerFeet = ({ children, ...props }) => (
    <Styled.ContainerFeet {...props}>{children}</Styled.ContainerFeet>
);
